import { lazy } from 'react';

export default {
  exact: true,
  name: 'MerchantPay',
  protected: true,
  path: '/pay-merchant',
  component: lazy(() => import('containers/MerchantPay')),
};
